import React from "react";

import Fidus_Web_A from "../Assets/gif/Fidus_Web_A1.gif"

const OurJourney = () => {
  return (
    <section id="section3">
      <div className="our_journey-section" id="our-journey">
        <div className="our_journey">
          <div className="heading">
            <h3>
              <span>Our</span> Journey
            </h3>
          </div>

          <div className="our_journey_vector">
            <img src={Fidus_Web_A} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurJourney;
